(function(){
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const NVH = window.NVH || {};

  function money(cents){
    const fmt = NVH.moneyFormat || '${{amount}}';
    const n = cents / 100;
    /* Shopify kent meerdere geldformaten; de euromarkt gebruikt amount_with_comma_separator */
    const group = (thousands, decimal, decimals) => {
      const parts = Math.abs(n).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return (n < 0 ? '-' : '') + parts.join(decimal);
    };
    const values = {
      amount: group(',', '.', 2),
      amount_no_decimals: group(',', '.', 0),
      amount_with_comma_separator: group('.', ',', 2),
      amount_no_decimals_with_comma_separator: group('.', ',', 0),
      amount_with_apostrophe_separator: group("'", '.', 2),
      amount_no_decimals_with_apostrophe_separator: group("'", '.', 0),
      amount_with_space_separator: group(' ', ',', 2),
      amount_no_decimals_with_space_separator: group(' ', ',', 0),
      amount_with_period_and_space_separator: group(' ', '.', 2)
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => (key in values ? values[key] : m))
              .replace(/<[^>]+>/g, '');
  }

  /* header: solid after scrolling past the hero on the home page */
  const header = $('[data-header]');
  if (header && document.body.classList.contains('tpl-index')){
    const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 60);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* generic dialog toggles */
  function openLayer(el, opener){
    if (!el) return;
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    el._opener = opener || document.activeElement;
    const f = el.querySelector('button, a, input'); if (f) f.focus({ preventScroll: true });
  }
  function closeLayer(el){
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (el._opener && el._opener.focus) el._opener.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') $$('[aria-hidden="false"][data-drawer],[aria-hidden="false"][data-mnav]').forEach(closeLayer);
  });
  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-mnav-open]')){ const b = t.closest('[data-mnav-open]'); b.setAttribute('aria-expanded','true'); openLayer($('[data-mnav]'), b); }
    if (t.closest('[data-mnav-close]')){ closeLayer($('[data-mnav]')); const b = $('[data-mnav-open]'); if (b) b.setAttribute('aria-expanded','false'); }
    if (t.closest('[data-drawer-close]')) closeLayer($('[data-drawer]'));
    const opener = t.closest('[data-cart-open]');
    if (opener && $('[data-drawer]') && !document.body.classList.contains('tpl-cart')){ e.preventDefault(); openLayer($('[data-drawer]'), opener); }
  });

  /* cart */
  const Cart = {
    sections: 'cart-drawer',
    async post(url, body){
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(Object.assign(body, { sections: this.sections, sections_url: window.location.pathname })) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'De winkelwagen kon niet worden bijgewerkt');
      return data;
    },
    render(data){
      const html = data.sections && data.sections['cart-drawer'];
      if (html){
        const wasOpen = $('[data-drawer]') && $('[data-drawer]').getAttribute('aria-hidden') === 'false';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-drawer]');
        const cur = $('[data-drawer]');
        if (fresh && cur){ cur.replaceWith(fresh); if (wasOpen) fresh.setAttribute('aria-hidden', 'false'); }
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => {
        $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
      }).catch(() => {});
    },
    async add(items){
      const data = await this.post((NVH.routes.cartAdd || '/cart/add') + '.js', { items });
      this.render(data); openLayer($('[data-drawer]'));
      return data;
    },
    async change(line, quantity){
      const d = $('[data-drawer]'); if (d) d.classList.add('is-busy');
      try { const data = await this.post((NVH.routes.cartChange || '/cart/change') + '.js', { line: Number(line), quantity: Number(quantity) }); this.render(data); }
      finally { const n = $('[data-drawer]'); if (n) n.classList.remove('is-busy'); }
    }
  };
  window.NVHCart = Cart;
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-line-qty]');
    if (q){ e.preventDefault(); Cart.change(q.dataset.lineQty, q.dataset.qty); }
    const a = e.target.closest('[data-quick-add]');
    if (a){ e.preventDefault(); a.classList.add('is-busy'); try { await Cart.add([{ id: Number(a.dataset.quickAdd), quantity: 1 }]); } catch(err){ alert(err.message); } finally { a.classList.remove('is-busy'); } }
  });

  /* ships-before date: today + handling business days */
  $$('[data-ship-date]').forEach(el => {
    const d = new Date(); let n = Number(el.dataset.shipDate || NVH.handlingDays || 2);
    while (n > 0){ d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    el.textContent = d.toLocaleDateString('nl-NL', { weekday: 'short', month: 'short', day: 'numeric' }).replace('.', '').toUpperCase();
  });

  /* chip filters (home feed + collection) */
  $$('[data-chip-filter]').forEach(root => {
    const limit = Number(root.dataset.limit || 0);
    const cards = $$('[data-cat]', root);
    const count = $('[data-filter-count]', root);
    const apply = cat => {
      let shown = 0;
      cards.forEach(c => { const ok = cat === 'all' || c.dataset.cat === cat; const vis = ok && (!limit || shown < limit); c.hidden = !vis; if (ok) shown++; });
      if (count){ const n = cat === 'all' ? cards.length : cards.filter(c => c.dataset.cat === cat).length; count.textContent = n + (n === 1 ? ' model' : ' modellen'); }
    };
    $$('[data-chip]', root).forEach(ch => ch.addEventListener('click', () => {
      $$('[data-chip]', root).forEach(x => x.setAttribute('aria-pressed', x === ch ? 'true' : 'false'));
      apply(ch.dataset.chip);
    }));
    apply('all');
  });

  /* x-ray comparison slider */
  $$('[data-compare]').forEach(stage => {
    const range = $('[data-compare-range]', stage);
    const set = v => stage.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => set(range.value));
    set(range.value);
  });

  /* size calculator */
  $$('[data-size-calc]').forEach(form => {
    const bounds = [22.4,23.2,23.9,24.7,25.4,26.2,26.9,27.7,28.4,29.2,29.9,30.7];
    const eu = ['36','37','38','39','40','41','42','43','44','45','46','47'];
    
    const out = $('[data-size-result]', form.parentNode);
    form.addEventListener('submit', e => {
      e.preventDefault();
      const cm = parseFloat(String(form.cm.value).replace(',', '.'));
      $$('[data-chart-row]').forEach(r => r.classList.remove('is-hit'));
      if (!cm || cm < 20 || cm > 31){ out.hidden = false; out.innerHTML = '<b>Vul een voetlengte in tussen 20 en 31 cm.</b>'; return; }
      let i = bounds.findIndex(b => cm <= b); if (i < 0) i = bounds.length - 1;
      out.hidden = false;
      out.innerHTML = '<b>Jouw maat: EU ' + eu[i] + '</b><br><span>Op basis van ' + cm + ' cm. Draag je dikke wollen sokken? Meet dan met de sok aan.</span>';
      const row = $('[data-chart-row="' + i + '"]'); if (row) row.classList.add('is-hit');
    });
  });

  /* product page */
  $$('[data-product]').forEach(root => {
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const variants = data.variants;
    const colorIdx = data.options.findIndex(o => /colou?r/i.test(o));
    const sizeIdx = data.options.findIndex(o => /size/i.test(o));
    const form = $('[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const atcs = $$('[data-atc]');
    const priceEls = $$('[data-product-price]');
    const err = $('[data-form-error]', root);
    const slides = $('[data-slides]', root);
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('[data-dot]', root);
    const state = { color: null, size: null };
    const pre = variants.find(v => v.id === Number(idInput.value)) || variants[0];
    if (colorIdx > -1) state.color = pre.options[colorIdx];
    if (sizeIdx < 0 || variants.length === 1) state.size = sizeIdx > -1 ? pre.options[sizeIdx] : null;
    if (data.preselectSize && sizeIdx > -1) state.size = pre.options[sizeIdx];

    function goTo(mediaId, smooth){
      if (!slides) return;
      const slide = $('[data-media-id="' + mediaId + '"]', slides);
      if (!slide) return;
      slides.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      mark(slide.dataset.index);
    }
    function mark(i){
      thumbs.forEach(t => t.setAttribute('aria-current', t.dataset.index === String(i) ? 'true' : 'false'));
      dots.forEach(d => d.classList.toggle('on', d.dataset.index === String(i)));
    }
    thumbs.forEach(t => t.addEventListener('click', () => goTo(t.dataset.mediaId, true)));
    if (slides){
      let raf;
      slides.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => mark(Math.round(slides.scrollLeft / slides.clientWidth))); }, { passive: true });
    }

    function current(){
      return variants.find(v => (colorIdx < 0 || v.options[colorIdx] === state.color) && (sizeIdx < 0 || v.options[sizeIdx] === state.size));
    }
    function update(fromColor){
      $$('[data-color]', root).forEach(b => b.setAttribute('aria-pressed', b.dataset.color === state.color ? 'true' : 'false'));
      const cn = $('[data-color-name]', root); if (cn && state.color) cn.textContent = state.color;
      $$('[data-size]', root).forEach(b => {
        const v = variants.find(x => (colorIdx < 0 || x.options[colorIdx] === state.color) && x.options[sizeIdx] === b.dataset.size);
        b.disabled = !v || !v.available;
        b.setAttribute('aria-pressed', b.dataset.size === state.size ? 'true' : 'false');
      });
      const v = current();
      if (fromColor){
        const withMedia = variants.find(x => x.options[colorIdx] === state.color && x.featured_media);
        if (withMedia) goTo(withMedia.featured_media.id, true);
      }
      if (v){
        idInput.value = v.id;
        priceEls.forEach(p => p.textContent = money(v.price));
        atcs.forEach(b => { b.disabled = !v.available; const l = b.querySelector('[data-atc-label]'); if (l) l.textContent = v.available ? (b.dataset.withPrice ? 'In winkelwagen, ' + money(v.price) : 'In winkelwagen') : 'Uitverkocht'; });
        if (!fromColor || !v.featured_media){ /* keep gallery */ }
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      } else {
        atcs.forEach(b => { b.disabled = false; const l = b.querySelector('[data-atc-label]'); if (l) l.textContent = b.dataset.withPrice ? 'In winkelwagen, ' + money(pre.price) : 'In winkelwagen'; });
      }
      if (err) err.hidden = true;
    }
    $$('[data-color]', root).forEach(b => b.addEventListener('click', () => { state.color = b.dataset.color; update(true); }));
    $$('[data-size]', root).forEach(b => b.addEventListener('click', () => { state.size = b.dataset.size; update(false); }));

    /* socks upsell */
    const upsell = $('[data-upsell]', root);
    const sockTotal = () => {
      if (!upsell) return;
      let total = 0;
      $$('[data-sock]', upsell).forEach(row => {
        const sel = $('select', row);
        const price = Number(sel ? sel.selectedOptions[0].dataset.price : row.dataset.price);
        const qty = Number(row.dataset.qty || 0);
        const deal = row.dataset.dealQty && qty === Number(row.dataset.dealQty) ? Math.round(Number(row.dataset.dealPrice) * 100) : null;
        const line = deal !== null ? deal : price * qty;
        total += line;
        const was = $('[data-sock-was]', row), save = $('[data-sock-save]', row);
        if (was){ was.hidden = deal === null; was.textContent = money(price * qty); }
        if (save){ save.hidden = deal === null; save.textContent = 'SAVE ' + money(price * qty - (deal || 0)); }
        $('[data-sock-price]', row).textContent = money(line);
      });
      $('[data-sock-total]', upsell).textContent = money(total);
    };
    if (upsell){
      $$('[data-sock]', upsell).forEach(row => {
        $$('[data-qty-pick]', row).forEach(p => p.addEventListener('click', () => {
          row.dataset.qty = p.dataset.qtyPick;
          $$('[data-qty-pick]', row).forEach(x => x.setAttribute('aria-pressed', x === p ? 'true' : 'false'));
          sockTotal();
        }));
        const sel = $('select', row); if (sel) sel.addEventListener('change', sockTotal);
      });
      sockTotal();
    }

    async function submit(e){
      if (e) e.preventDefault();
      const v = current();
      if (!v){
        if (err){ err.hidden = false; err.textContent = sizeIdx > -1 && !state.size ? 'Kies eerst je maat.' : 'Deze combinatie is niet beschikbaar.'; }
        const sz = $('[data-size-block]', root); if (sz) sz.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const items = [{ id: v.id, quantity: 1 }];
      if (upsell){
        $$('[data-sock]', upsell).forEach(row => {
          const qty = Number(row.dataset.qty || 0); if (!qty) return;
          const sel = $('select', row);
          items.push({ id: Number(sel ? sel.value : row.dataset.variant), quantity: qty });
        });
      }
      atcs.forEach(b => b.classList.add('is-busy'));
      try { await Cart.add(items); }
      catch(ex){ if (err){ err.hidden = false; err.textContent = ex.message; } }
      finally { atcs.forEach(b => b.classList.remove('is-busy')); }
    }
    form.addEventListener('submit', submit);
    $$('[data-atc-proxy]').forEach(b => b.addEventListener('click', e => { if (!current()){ e.preventDefault(); const t = $('[data-size-block]', root) || form; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (err){ err.hidden = false; err.textContent = 'Kies eerst je maat.'; } return; } submit(e); }));

    /* sticky ATC on mobile once the main button leaves the viewport */
    const sticky = $('[data-sticky-atc]');
    const mainAtc = $('[data-atc]', form);
    if (sticky && mainAtc && 'IntersectionObserver' in window){
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainAtc);
    }
    update(false);
    if (pre.featured_media && new URL(window.location.href).searchParams.get('variant')) goTo(pre.featured_media.id, false);
  });
})();

/* secties rustig laten opkomen; eerste scherm blijft staan */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var secs = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
  var watched = [];
  /* secties met een vast gepositioneerd element (winkelwagenlade, sticky knop) nooit animeren:
     een transform op de ouder maakt position:fixed daarbinnen kapot */
  var FIXED_INSIDE = '[data-drawer],[data-sticky-atc],[data-sticky],dialog,[data-cart-drawer]';
  secs.forEach(function(sec){
    if (sec.querySelector(FIXED_INSIDE)) return;
    if (sec.getBoundingClientRect().top < window.innerHeight * 0.9) return; // al in beeld
    sec.setAttribute('data-reveal', '');
    io.observe(sec);
    watched.push(sec);
  });
  /* vangnet: nooit een lege sectie laten staan, ook niet bij springen of een trage waarnemer */
  var flush = function(){
    watched.forEach(function(sec){
      var r = sec.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) sec.classList.add('is-in');
    });
  };
  window.addEventListener('scroll', flush, { passive: true });
  window.addEventListener('resize', flush, { passive: true });
  setTimeout(flush, 400);
  window.addEventListener('beforeprint', function(){ watched.forEach(function(s){ s.classList.add('is-in'); }); });
})();

/* kortingscode: Shopify past een code toe via /discount/CODE en stuurt daarna terug */
(function(){
  var root = (window.NVH && NVH.routes && NVH.routes.root) || '';
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-discount-toggle]');
    if (t){
      var row = t.parentElement.querySelector('.disc__row');
      row.hidden = !row.hidden;
      t.setAttribute('aria-expanded', String(!row.hidden));
      if (!row.hidden) row.querySelector('input').focus();
      return;
    }
    var a = e.target.closest('[data-discount-apply]');
    if (!a) return;
    var wrap = a.closest('[data-discount]');
    var input = wrap.querySelector('[data-discount-input]');
    var msg = wrap.querySelector('[data-discount-msg]');
    var code = (input.value || '').trim();
    if (!code){ msg.hidden = false; msg.className = 'disc__msg is-err'; msg.textContent = 'Vul eerst een code in.'; input.focus(); return; }
    a.classList.add('is-busy');
    var back = root + '/cart?dc=' + encodeURIComponent(code);
    window.location.href = root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });
  /* terug van /discount/: kijken of de code echt is aangeslagen */
  var dc = new URLSearchParams(location.search).get('dc');
  if (dc){
    fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      var ok = (c.cart_level_discount_applications || []).some(function(d){
        return (d.title || '').toUpperCase() === dc.toUpperCase() || (d.key || '').toUpperCase().indexOf(dc.toUpperCase()) > -1;
      });
      var wrap = document.querySelector('[data-discount]');
      if (!wrap) return;
      var row = wrap.querySelector('.disc__row'), msg = wrap.querySelector('[data-discount-msg]');
      row.hidden = false; msg.hidden = false;
      msg.className = 'disc__msg ' + (ok ? 'is-ok' : 'is-err');
      msg.textContent = ok ? ('Code ' + dc.toUpperCase() + ' is toegepast.') : ('Code ' + dc.toUpperCase() + ' werkt niet. Controleer de code of de voorwaarden ervan.');
      if (ok) wrap.querySelector('[data-discount-input]').value = '';
    }).catch(function(){});
    history.replaceState({}, '', location.pathname);
  }
})();
